import { departmentLabel, won } from '../financeApi';
import { STATUS_INFO, type ExpenseRequest } from './expenseTypes';

// 지출 결의서 인쇄 양식(결재란 포함). PrintPortal 안에서 그린다.
export default function ExpenseRequestPrint({ request }: { request: ExpenseRequest }) {
  return (
    <div className="fin-doc">
      <div className="fin-doc-head">
        <h1>지 출 결 의 서</h1>
        <table className="fin-doc-sign">
          <tbody>
            <tr><th rowSpan={2}>결<br />재</th><th>담당</th><th>부서장</th><th>재정부장</th><th>담임목사</th></tr>
            <tr>
              <td />
              <td>{request.deptApproverName}</td>
              <td>{request.financeApprovedAt ? '승인' : ''}</td>
              <td />
            </tr>
          </tbody>
        </table>
      </div>
      <table className="fin-doc-table">
        <tbody>
          <tr><th>문서번호</th><td>제 {request.id} 호</td><th>청구일</th><td>{request.requestDate.slice(0, 10)}</td></tr>
          <tr><th>청구 부서</th><td>{departmentLabel(request.department)}</td><th>청구자</th><td>{request.requesterName}</td></tr>
          <tr><th>계정과목</th><td>{request.category}</td><th>진행 상태</th><td>{STATUS_INFO[request.status].label}</td></tr>
          <tr><th>제목</th><td colSpan={3}>{request.title}</td></tr>
          <tr><th>금액</th><td colSpan={3}><b>금 {won(request.amount)}정</b></td></tr>
          <tr><th>지급처</th><td colSpan={3}>{[request.payee, request.payMethod, request.bankAccount].filter(Boolean).join(' / ')}</td></tr>
          <tr><th>청구 내용</th><td colSpan={3} className="fin-doc-tall">{request.description}</td></tr>
          <tr><th>지급일</th><td colSpan={3}>{request.paidDate ?? ''}</td></tr>
        </tbody>
      </table>
      <p className="fin-doc-foot">위 금액을 지출하고자 하오니 결재하여 주시기 바랍니다. (증빙 {request.attachments?.length ?? request.attachmentCount ?? 0}매 첨부)</p>
    </div>
  );
}
